var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNewZealand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.0001H16C16 15.9857 16 15.9717 16 15.9573C15.9857 15.9716 15.9715 15.9858 15.9572 16.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.162 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0486 16H15.9572C15.9715 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09469 2.08691C5.59226 3.51185 3.51188 5.59223 2.08694 8.09466V16H6.26088V6.26098V6.26085H16C16 4.94441 16 3.69029 16 2.08691H8.09469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0325L10.3154 8.3479C10.3154 8.3479 8.34787 8.34803 8.34787 8.3479V8.34803L15.9999 16H16C16 16 16 14.6433 16 14.0325Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7081 11.8723L28.0534 12.9352H29.171L28.2669 13.5921L28.6122 14.6549L27.7081 13.9981L26.8039 14.6549L27.1493 13.5921L26.2451 12.9352H27.3627L27.7081 11.8723Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7132 19.5247L24.2313 21.119H25.9076L24.5513 22.1043L25.0695 23.6986L23.7132 22.7133L22.357 23.6986L22.8751 22.1043L21.5188 21.119H23.1951L23.7132 19.5247Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8638 7.00293L24.2955 8.33162H25.6924L24.5622 9.15255L24.9939 10.4812L23.8638 9.65999L22.7336 10.4812L23.1653 9.15255L22.0352 8.33162H23.4321L23.8638 7.00293Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0206 11.8262L20.5386 13.4205H22.215L20.8587 14.4058L21.3768 16.0001L20.0206 15.0148L18.6643 16.0001L19.1825 14.4058L17.8262 13.4205H19.5025L20.0206 11.8262Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNewZealand);
export default __webpack_public_path__ + "static/media/flag_new_zealand.12c7987d09d74026db1be8215f678e5b.svg";
export { ForwardRef as ReactComponent };